/*
 * @Author: Teemo Ding
 * @Date: 2022-03-24 16:03:06
 * @LastEditTime: 2022-06-29 15:02:08
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Voucher/Detail/Header/TopLeft/index.tsx
 */
import { get } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';

const TopLeft = (props) => {
  const { name, salesChannelName, getI18n } = props;
  const s = useParams();
  // const uuid = get(s, 'uuid');
  //  const discountUuid = get(s, 'discountUuid');
  const salesChannelUuid = get(s, 'uuid');
  const h = useHistory();
  const goBack = () => {
    h.push(`/salesChannel/discounts/voucher/list/${salesChannelUuid}`);
  };

  const b = (name, salesChannelName) => [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/salesChannels`,
      name: getI18n('general.sider.salesChannel'),
    },
    {
      url: `/salesChannel/content/${salesChannelUuid}`,
      name: salesChannelName,
    },
    { url: '', name: getI18n('general.sider.discounts') },
    {
      url: `/salesChannel/discounts/voucher/list/${salesChannelUuid}`,
      name: getI18n('general.sider.voucher'),
    },
    {
      url: ``,
      name: name,
    },
  ];
  return (
    <_TopLeft goBack={goBack} breadcrumbData={b(name, salesChannelName)} />
  );
};
export default TopLeft;
